import * as API from '@/endpoints'
import Axios from 'axios'
import { Message } from 'iview'

export default {
  namespaced: true,
  state: {
    careteam: {}
  },
  mutations: {
    setCareteamList(state, v) {
      Vue.set(state, 'careteam', v)
    }
  },
  actions: {
    getCareTeamOwner({commit}, {id})  {
      return new Promise((resolve, reject) => {
        let url = `${API.endpoints.user}/${id}`
        Axios.get(url)
        .then(res => {
          console.log('CARETEAM', res.data)
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    getPendingCareTeamsList({commit}, {journal_id})  {
      return new Promise((resolve, reject) => {
        let url = `${API.endpoints.journal}/${journal_id}/careplans/pending`
        Axios.get(url)
        .then(res => {
          commit('setCareteamList', res.data)
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    bookmark({commit, dispatch, state}, {id, type}) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.bookmark, {
          item_id: id,
          type
        })
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    acceptCareTeamPrescribe ({dispatch}, {id}) {
      return new Promise((resolve, reject) => {
        let url = `${API.endpoints.careplan}/${id}/accept`
        Axios.post(url)
        .then(res => {
          Message.info("Care Team invite accepted");
          resolve(res.data)
        })
        .catch(err => {
          Message.error('Unable to accept Care Team invitation')
          reject(err)
        })
      })
    },
    acceptCareTeamRequest ({dispatch}, {id}) {
      return new Promise((resolve, reject) => {
        let url = `${API.endpoints.base}accept/private/careplan/request/${id}`
        Axios.put(url)
        .then(res => {
          Message.info("Care Team request accepted");
          resolve(res.data)
        })
        .catch(err => {
          Message.error('Unable to accept Care Team request')
          reject(err)
        })
      })
    },
    rejectCareTeamInvite ({commit}, {id}) {
      return new Promise((resolve, reject) => {
        let url = `${API.endpoints.careplan}/${id}/remove`
        Axios.delete(url)
        .then(res => {
          Message.info('Care Team invite rejected.')
          console.log('REJECT', res.data)
          commit('notification/removeNotificationById', id, {root:1})
          resolve(res.data)
        })
        .catch(err => {
          let msg = response.message || err.response.data.error.message
          Message.error(msg)
          reject(err)
        })
      })
    },
  }
}
